import { getEnv } from 'util/getEnv';

export const getClientAlias = () => {
  const split = window.location.hostname.split('.');
  const subdomain = split[0];
  const dash = split[1];
  const envAlias = getEnv('REACT_APP_DEFAULT_CLIENT');

  let alias;

  switch (getEnv('NODE_ENV')) {
    case 'production':
      alias = dash === 'dashboard' ? subdomain : envAlias;
      break;

    default:
      alias = dash === 'dashboard' ? subdomain : envAlias;
  }

  return alias;
};

export const getUrlParts = () => {
  const split = window.location.hostname.split('.');
  let alias, env;

  if (split?.[1] === 'dashboard') {
    alias = split[0];
    env = split[2];
  } else {
    alias = getEnv('REACT_APP_DEFAULT_CLIENT');
    env = getEnv('REACT_APP_ADMIN_API_URL').split('//')[1].split('.')[1];
  }

  return { alias, env };
};
